import React from 'react';
import './qualification-box.scss';

export default function QualificationBox({
  qualificationTitle,
  qualificationSubTitle,
  qualificationMeasure,
}) {
  return (
    <div className="QualificationBox box why-you-qualify-box">
      <p className="box-title">
        {qualificationTitle}
      </p>
      <p className="box-subtitle">
        {qualificationSubTitle}
      </p>
      <p className="box-measure">
        {qualificationMeasure}
      </p>
    </div>
  );
}
